import React, { useEffect, useState } from 'react'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'

const PermitToWorkTemplates = () => {
  const { setPageLoading } = useOutletContext()
  
  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()

  const [formTemplates, setFormTemplates] = useState([])

  useEffect(() => {
    const getEquipments = async () => {
      const body = await send({
        method: "GET",
        url: `${apiUrl}/permit_to_work/templates`,
        returnType: "json"
      })

      body && setFormTemplates(body)
    }

    setPageLoading(true)

    const init = async () => {
      await Promise.all([
        getEquipments()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  const onClick = (e, row) => {
    navigate(`./${row["template_id"]}`)
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={formTemplates} count={null}
              onRowClick={onClick}
              columns={{
                "template_name": { "label": t("ptw_templateName"), "sorting": false, "nowrap": false },
                "template_no": { "label": t("ptw_templateNo"), "sorting": false, "nowrap": true },
                "description": { "label": t("ptw_equipmentDescription"), "sorting": false, "nowrap": false },
                "effective_date": { "label": t("ptw_effectiveDate"), "sorting": false, "nowrap": true }
              }}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 
  </>)
}

export default PermitToWorkTemplates
